import { render, staticRenderFns } from "./Pdetails.vue?vue&type=template&id=558ef744&scoped=true"
import script from "./Pdetails.vue?vue&type=script&lang=js"
export * from "./Pdetails.vue?vue&type=script&lang=js"
import style0 from "./Pdetails.vue?vue&type=style&index=0&id=558ef744&prod&scoped=true&lang=scss"
import style1 from "./Pdetails.vue?vue&type=style&index=1&id=558ef744&prod&scoped=true&lang=css"
import style2 from "./Pdetails.vue?vue&type=style&index=2&id=558ef744&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558ef744",
  null
  
)

export default component.exports